import { render, staticRenderFns } from "./UserPictureUI.vue?vue&type=template&id=74a8fb50&lang=pug&"
import script from "./UserPictureUI.vue?vue&type=script&lang=js&"
export * from "./UserPictureUI.vue?vue&type=script&lang=js&"
import style0 from "./UserPictureUI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports